module.exports = __webpack_public_path__ + "img/queue-2.d8025eca.svg";